<template>
  <div class="team-detailed-revise" >
    <div class="team" >
      <div class="team-res">
        <!-- add team logo start -->
        <div class="logo" >
          <h3>球队Logo</h3>
          <van-uploader :disabled="routerParams.type === 'read'" :after-read="afterReadLogo" :accept="accept" upload-text="图片小于5M" >
            <van-icon v-if="!teamInfo.badge" name="plus" size="22px" />
            <img v-if="teamInfo.badge" :src="filterImage()">
          </van-uploader>
        </div>
        <div class="logo badge" >
          <h3>球队合影</h3>
          <van-uploader :disabled="routerParams.type === 'read'" :after-read="afterReadBadge" :accept="accept" upload-text="图片小于5M" >
            <van-icon v-if="!teamInfo.background" name="plus" size="22px" />
            <img v-if="teamInfo.background" :src="filterImageBadge()">
          </van-uploader>
        </div>
        <!-- end -->
      </div>
      <div v-if="membershipId" style="position: relative">
        <van-cell-group title="球队名称" >
          <van-field :disabled="routerParams.type === 'read'" v-model="teamInfo.longName" placeholder="请输入球队名称" />
        </van-cell-group>
        <van-cell-group title="球队简称" >
          <van-field :disabled="routerParams.type === 'read'" v-model="teamInfo.name" placeholder="请输入球队简称" />
        </van-cell-group>
        <van-tabs v-model="TabActive" v-show="routerParams.type === 'update' || routerParams.type === 'read'">
          <van-button v-show="routerParams.type !== 'read'" class="add-btn-player" type="default" @click="isShowPlayer=true">添加球员</van-button>
          <van-tab title="参赛球员">
            <div class="search">
              <van-checkbox-group>
                <van-cell-group>
                  <van-cell>
                    <van-row class="row-checkbox" type="flex" align="center" >
                      <van-col span="4" >姓名</van-col>
                      <!--<van-col span="3" >性别</van-col>-->
                      <van-col span="3" >位置</van-col>
                      <van-col span="6" >生日</van-col>
                      <van-col span="4" >号码</van-col>
                      <van-col span="6" >证件号</van-col>
                      <van-col span="1" >操作</van-col>
                    </van-row>
                  </van-cell>
                  <van-cell
                    v-if="teamPlayers.length>0"
                    v-for="(item, index) in teamPlayers"
                    clickable
                    :key="item.id">
                    <van-row class="row-checkbox" type="flex" align="center" >
                      <van-col span="4" >{{ item.trueName }}</van-col>
                      <!--<van-col span="3" >{{ item.gender }}</van-col>-->
                      <van-col span="3" ><span @click="showPopupPos(index)">{{ item.position }}</span></van-col>
                      <van-col span="6" >{{ formatDate(item.birthDay) }}</van-col>
                      <van-col span="4"><span @click="showPopup(item.jerseyNo, index)">{{ item.jerseyNo }}</span></van-col>
                      <van-col span="6" style="word-break: break-word;">{{ item.certificateNum }}</van-col>
                      <van-col span="1">
                        <van-icon v-show="routerParams.type != 'read'" name="cross" @click="deleteTeamPlayer(item.id)"/>
                      </van-col>
                    </van-row>
                  </van-cell>
                  <van-cell v-if="teamPlayers.length==0">
                    <van-row style="text-align: center" >
                      暂无参赛球员
                    </van-row>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </div>
          </van-tab>
          <van-tab title="选择官员">
            <div class="search" >
            </div>
            <van-cell-group>
              <van-field label="领队" v-model="coaches[0].trueName" placeholder="请选择领队" readonly @click="showCoachPage(0)" />
              <van-field label="副领队" v-model="coaches[1].trueName" placeholder="请选择副领队" readonly @click="showCoachPage(1)" />
              <van-field label="主教练" v-model="coaches[2].trueName" placeholder="请选择主教练" readonly @click="showCoachPage(2)" />
              <van-field label="助理教练" v-model="coaches[3].trueName" placeholder="请选择助理教练" readonly @click="showCoachPage(3)" />
              <van-field label="队医" v-model="coaches[4].trueName" placeholder="请选择队医" readonly @click="showCoachPage(4)" />
            </van-cell-group>
          </van-tab>
          <van-tab disabled ></van-tab>
        </van-tabs>
      </div>
      <div class="team-btn" v-if="routerParams.type === 'update'">
        <van-button type="primary" @click="updateTeam()" >更新</van-button>
        <van-button  type="primary" @click="signup" >报名</van-button>
      </div>
      <div class="team-btn-create" v-if="routerParams.type === 'create'">
        <van-button type="primary" size="large" @click="createTeam" >创建</van-button>
      </div>
    </div>

    <!-- popo -->
    <van-popup class="number-input" v-model="isShowPopup" position="bottom" >
      <div class="header">
        <div class="left-btn" @click="isShowPopup=false">取消</div>
        <div class="right-btn" @click="confirmPopup">确定</div>
      </div>
      <div class="content">
        <van-cell-group>
          <van-field type="number" v-model="currentJerseyNo" placeholder="请输入球衣号" />
        </van-cell-group>
      </div>
    </van-popup>

    <!-- popup -->
    <van-popup v-model="isShowPopupPos" position="bottom" :overlay="true">
      <van-picker show-toolbar @confirm="confirmPopupPos" @cancel="isShowPopupPos=false" :columns="columnsPos" ></van-picker>
    </van-popup>
    <!-- 球员列表 start-->
    <van-popup class="player-list" v-model="isShowPlayer" :overlay="false">
      <van-button style="border: none;" type="default" @click="isShowPlayer=false">&lt; 返回</van-button>
      <van-button style="float: right;border: none;" type="default" @click="addTeamPlayers">确认</van-button>
      <van-search
        v-model="searchPlayerText"
        placeholder="请输入球员关键词"
        shape="round"
        @change="searchPlayer"
        @search="searchPlayer">
        <div slot="action" @click="searchPlayer">搜索</div>
      </van-search>
      <div class="search team-list" >
        <van-checkbox-group v-model="selectedPlayers">
          <van-cell-group>
            <van-cell>
              <van-row class="row-checkbox" type="flex" align="center" >
                <van-col span="4" >姓名</van-col>
                <van-col span="3" >性别</van-col>
                <van-col span="3" >位置</van-col>
                <van-col span="4" >生日</van-col>
                <van-col span="3" >号码</van-col>
                <van-col span="4" >证件号</van-col>
                <van-col span="3" >操作</van-col>
              </van-row>
            </van-cell>
            <van-cell
              v-for="item in playerList"
              clickable
              :key="item.id">
              <van-row class="row-checkbox" type="flex" align="center" >
                <van-col span="4" >{{ item.trueName }}</van-col>
                <van-col span="3" >{{ item.gender }}</van-col>
                <van-col span="3" >{{ item.position}}</van-col>
                <van-col span="4" >{{ formatDate(item.birthday) }}</van-col>
                <van-col span="3" >{{ item.jerseyNo }}</van-col>
                <van-col span="4" >{{ item.certificateNum }}</van-col>
                <van-col span="3" >
                  <van-checkbox :name="item" checked-color="#185494" />
                </van-col>
              </van-row>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </van-popup>
    <!-- end -->

    <!-- 教练列表 start-->
    <van-popup class="player-list" v-model="isShowCoach" :overlay="false">
      <van-button style="border: none;" type="default" @click="isShowCoach=false"> &lt; 返回</van-button>
      <van-button style="float: right;border: none;" type="default" @click="updateTeamCoaches">确认</van-button>
      <van-search
        v-model="searchCoachText"
        placeholder="请输入教练关键词"
        shape="round"
        @change="searchCoach"
        @search="searchCoach">
        <div slot="action" @click="searchCoach">搜索</div>
      </van-search>
      <div class="search" >
        <van-radio-group v-model="selectedCoach">
          <van-cell-group>
            <van-cell>
              <van-row class="row-checkbox" type="flex" align="center" >
                <van-col span="16" >姓名</van-col>
                <van-col span="6" > 手机号</van-col>
                <van-col span="2" > 操作</van-col>
              </van-row>
            </van-cell>
            <van-cell
              v-for="item in coachList"
              clickable
              :key="item.id">
              <van-row class="row-checkbox" type="flex" align="center" >
                <van-col span="16" >{{ item.trueName }}</van-col>
                <van-col span="6" >{{ item.mobile }}</van-col>
                <van-col span="2" >
                  <van-radio :name="item" checked-color="#185494" />
                </van-col>
              </van-row>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-popup>
    <!-- end -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import { getMyOrganization } from '@/api/info'
import { ImageFormat, ConstConfig } from '@/utils'
import { getQiniuUploadToken } from '@/api/user'
import { getPlayerList, getCoachList, getTeam, updateTeamCoaches, updateTeamPlayers, updateTeam, organizationTeamSighUpMatchGroup,
createTeam, getGroupTeam, addTeamPlayers, deleteTeamPlayer} from '@/api/match'
import { Button, Popup, Field, Search, List, Checkbox, CheckboxGroup, Toast, Row, Col, Tab, Tabs, Cell, CellGroup, Uploader,
  Icon } from 'vant'
Vue.use({ Button, Popup, Field, Search, List, Checkbox, CheckboxGroup, Toast}).use(Row).use(Col).use(Tab).use(Tabs).use(Cell).use(Uploader)
  .use(CellGroup).use(Icon)
export default {
  name: 'TeamDetailedRevise',
  data() {
    return {
      TabActive: 0,
      teamId: null,
      teamInfo: {
        name: null,
        longName: '',
        searchText: null,
        pageNum: 0,
        pageSize: 99999,
        playerList: [],
        coachList: [],
        badge: null,
        background: null
      },
      playerFinished: false,
      coachList: [],
      playerList: [],
      membershipId: null,
      routerParams: false,
      playerLoading: false,
      accept: 'image/jpeg,image/gif,image/png,image/bmp',
      coaches: [
        { role: '领队', id: '' },
        { role: '副领队', id: '' },
        { role: '主教练', id: '' },
        { role: '助理教练', id: '' },
        { role: '队医', id: '' }
      ],
      isShowPopup: false,
      key: null,
      value: null,
      searchPlayerText: '',
      searchCoachText: '',
      teamPlayers: [],
      selectedPlayers: [],
      selectedCoach: '',
      isShowPlayer: false,
      isShowCoach: false,
      coachIndex: 0,
      currentJerseyNo: 0,
      jerseyIndex: 0,
      posIndex: 0,
      isShowPopupPos: false,
      currentPos: '',
      columnsPos: ['前锋','后卫','守门员']
    }
  },
  created() {
    this.routerParams = this.$route.query
    this.teamId = this.routerParams.teamId
    this.getMyOrganization() //获取当前会员单位，球员待选范围
    this.getQiniuToken()
    this.getGroupTeam()
  },
  methods: {
    getGroupTeam() { // 参赛球队信息（包含参赛球员）
      if (!this.teamId) {
        return
      }
      let params = {
        groupId: this.routerParams.groupId,
        teamId: this.routerParams.teamId
      }
      getGroupTeam(params).then(response => {
        let team = response.data.team
        this.teamInfo.name = team.name
        this.teamInfo.longName = team.longName
        this.teamInfo.badge = team.badge
        this.teamInfo.background = team.background
        // 球员
        this.teamPlayers = team.players
        // 教练
        team.coaches.filter(item => {
          if (item.role === '领队') {
            this.coaches[0] = item
          } else if (item.role === '副领队') {
            this.coaches[1] = item
          } else if (item.role === '主教练') {
            this.coaches[2] = item
          } else if (item.role === '助理教练') {
            this.coaches[3] = item
          } else if (item.role === '队医') {
            this.coaches[4] = item
          }
        })
      })
    },
    showPopup(number, index) {
      this.jerseyIndex = index
      this.currentJerseyNo = number
      this.isShowPopup = true
    },
    confirmPopup() {
      const index = this.jerseyIndex
      this.teamPlayers[index].jerseyNo = this.currentJerseyNo
      this.isShowPopup = false
    },
    showPopupPos(index) {
      this.posIndex = index
      this.isShowPopupPos = true
    },
    confirmPopupPos(value) {
      const index = this.posIndex
      this.teamPlayers[index].position = value
      this.isShowPopupPos = false
    },
    searchPlayer() {
      this.getPlayerList()
    },
    getPlayerList() {
      let params = {
        organizationId: this.membershipId,
        trueName: this.searchPlayerText,
        opStatus: 2,
        pageSize: 9999
      }
      getPlayerList(params).then((resolve) => {
        let data = resolve.data
        if (data) {
          // 处理数据
          this.playerList = data.list
//          if (this.teamId) {
//            this.getTeam()
//          }
        }
      })
    },
    showCoachPage(index) {
      if (this.routerParams.type === 'read') return
      if (this.coaches[index] && this.coaches[index].id) {
        for (let coach of this.coachList) {
          if (this.coaches[index].id === coach.id) {
            this.selectedCoach = coach
          }
        }
      }
      this.coachIndex = index
      this.isShowCoach = true
    },
    searchCoach() {
      this.getCoachList()
    },
    getCoachList() {
      const params = {
        organizationId: this.membershipId,
        trueName: this.searchCoachText
      }
      getCoachList(params).then((resolve) => {
        let data = resolve.data
        this.coachList = data.list
      })
    },
    getMyOrganization() {
      getMyOrganization().then((resolve) => {
        let data = resolve.data
        this.membershipId = data.membership.id
        this.getCoachList()
        this.getPlayerList()
      })
    },
    addTeamPlayers() {
      let params = {
        teamId: this.teamId
      }
      if (this.selectedPlayers.length === 0) {
        Toast('请先选择球员')
        return
      }
      this.selectedPlayers.map(item => {
        if (item.id) {
          item.playerId = String(item.id)
          item.jerseyNo = item.jerseyNo ? item.jerseyNo : '0'
          delete item.id
        }
      })
      params.players = JSON.stringify(this.selectedPlayers)
      addTeamPlayers(params).then(res => {
        const data = res.data
        if (data) {
          this.getGroupTeam()
          this.isShowPlayer=false
          Toast('添加球员成功')
        }
      })
    },
    updateTeamPlayers() {
      let params = {
        teamId: this.teamId,
        players: JSON.stringify(this.teamPlayers)
      }
      updateTeamPlayers(params).then(res => {
        const data = res.data
        if (data) {
          this.getGroupTeam()
          // 保存就可以直接报名
          this.signup()
          Toast('更新成功')
        }
      })
    },
    deleteTeamPlayer(playerId) {
      let params = {
        teamId: this.teamId,
        ids: playerId
      }
      deleteTeamPlayer(params).then(res => {
        const data = res.data
        if (data) {
          this.getGroupTeam()
          Toast('删除成功')
        }
      })
    },
    updateTeamCoaches() {
      const index = this.coachIndex
      this.coaches[index].id = this.selectedCoach.id
      let params = {
        teamId: this.teamId,
        coaches: JSON.stringify(this.coaches)
      }
      updateTeamCoaches(params).then(res => {
        const data = res.data
        if (data) {
          this.getGroupTeam()
        }
      })

      this.isShowCoach = false
      this.getGroupTeam()
    },
    updateTeam() {
      let params = {
        name: this.teamInfo.name,
        longName: this.teamInfo.longName,
        teamId: this.teamId,
        badge: this.teamInfo.badge,
        background: this.teamInfo.background,
        groupId: this.routerParams.groupId
      }
      if (this.teamInfo.name.length == 0) {
        Toast('球队简称不能为空')
        return
      }
      const len = this.getStrLength(this.teamInfo.name)
      if (len  > 10) {
        Toast('球队简称长度不能大于5个中文字符')
        return
      }
      updateTeam(params).then((resolve) => {
        if (resolve && resolve.data) {
          Toast('更新球队成功')
        }
      })
      this.updateTeamPlayers()
    },
    getStrLength (str) {
      var cArr = str.match(/[^\x00-\xff]/ig);
      return str.length + (cArr == null ? 0 : cArr.length);
    },
    createTeam() {
      let params = {
        name: this.teamInfo.name,
        longName: this.teamInfo.longName,
        coaches: JSON.stringify(this.coaches),
        badge: this.teamInfo.badge,
        background: this.teamInfo.background,
        organizationId: this.membershipId,
        groupId: this.routerParams.groupId
      }
      if (this.teamInfo.name.length == 0) {
        Toast('球队简称不能为空')
        return
      }
      if (this.teamInfo.name.length > 5) {
        Toast('球队简称长度大于5个字')
        return
      }
      createTeam(params).then((resolve) => {
        if (resolve && resolve.data) {
          Toast('创建成功')
          this.$router.replace({
            path: '/team-detailed-revise',
            query: {
              type: 'update',
              groupId: this.routerParams.groupId,
              teamId: resolve.data.id
            }
          })
          location.reload()
        }
      })
    },
    signup() {
      let params = {
        teamId: this.teamId,
        players: JSON.stringify(this.teamPlayers)
      }
      if (this.teamInfo.name.length == 0) {
        Toast('球队简称不能为空')
        return
      }
      if (this.teamInfo.name.length > 5) {
        Toast('球队简称长度大于5个字')
        return
      }
      updateTeamPlayers(params).then(res => {
        const data = res.data
        if (data) {
          this.organizationTeamSighUpMatchGroup()
        }
      })
    },
    organizationTeamSighUpMatchGroup(teamId) {
      let params = {
        teamId: this.teamId,
        groupId: this.routerParams.groupId
      }
      organizationTeamSighUpMatchGroup(params).then((resolve) => {
        const data = resolve.data
        if (data && data.update === 1) {
          Toast('报名成功')
          this.$router.go(-1)
        }
      })
    },
    uploadFile(file) {
      let formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      }
      return new Promise((resolve, reject) => {
        axios.post(ConstConfig.qiniuUpload, formData, config).then(res => {
          const data = res.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.qiniuToken = data.token
      }).catch(err => {
        Toast('七牛Token获取失败')
      })
    },
    afterReadLogo(file) {
      this.uploadFile(file).then(res => {
        if (res) {
          this.teamInfo.badge = res.hash
        }
      })
    },
    afterReadBadge(file) {
      this.uploadFile(file).then(res => {
        if (res) {
          this.teamInfo.background = res.hash
        }
      })
    },
    filterImage() {
      return ImageFormat.squareImageView(this.teamInfo.badge, 156)
    },
    filterImageBadge() {
      return ImageFormat.squareImageView1(this.teamInfo.background, 150, 78)
    },
    selectCoacheRole(key) {
      this.key = key
      this.isShowPopup = true
    },
    setCoacheRole(value) {
      this.coaches[this.key].id = value.id
      this.coaches[this.key].trueName = value.trueName
      this.isShowPopup = false
    },
    formatDate(date) {
      let ret = ''
      if (date) {
        ret = moment(date).format('YYYY-MM-DD')
      }
      return ret
    }
  }
}
</script>
<style lang="scss">
  .team-detailed-revise {
    max-width: 768px; /*px*/
    h2 {
      margin: 0;
      font-weight: 400;
      font-size: 16px;
      color: rgba(69, 90, 100, 1);
      padding: 15px 15px 0;
    }
    .team-list {
      .van-col {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-word;
      }
    }
    .team {
      width: 100%;
      height: 100%;
      .van-tab--active {
        color: #185494;
      }
      .van-tabs {
        padding-bottom: 70px;
      }
      .van-tabs__line {
        background-color: #185494;
      }
      .van-col {
        color: #818181;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-word;
      }
      .van -cell-group__title {
        margin: 0;
        font-weight: 400;
        font-size: 16px;
        color: rgba(69, 90, 100, 1);
        padding: 10px 15px 15px;
      }
      .search {
        /*min-height: 80px;
        max-height: 300px;

        position: fixed;
        height: calc(100% - 250px);
        width: 100%;
        overflow-y: scroll;
        */
      }
      .van-search {
        background-color: white;
        .van-search__content {
          background-color: white;
          border: 1px solid rgba(230,230,230,1);
          height: 45px;
          border-radius: 45px;
          line-height: 45px;
          .van-cell {
            .van-field__left-icon {
              display: flex;
              align-items: center;
              .van-icon {
                font-size: 28px;
                color: #979797;
              }
            }
            .van-cell__value {
              display: flex;
              align-items: center;
              color: #E2E2E2;
              font-size: 14px;
              .van-field__body {
                width: 100%;
              }
            }
          }
        }
      }
      .van-checkbox-group {
        .van-checkbox {
          padding: 10px;
          .van-checkbox__label {
            width: auto;
            div {
              display: inline-block;
              padding: 0 10px;
            }
          }
        }
      }
      .team-btn {
        max-width: 768px; /*px*/
        position: fixed;
        bottom: 0;
        left: 50%;
        width: 100%;
        text-align: center;
        background-color: white;
        button:first-child {
          background-color: white;
          color: #185494;
        }
        button:last-child {
          background-color: #185494;
          color: white;
        }
        button {
          font-size: 20px;
          height: 60px;
          padding: 0;
          margin: 0;
          border: none;
          width: calc(50% - 3px);
          left: -50%;
        }
      }
      .van-cell-group__title {
        font-size: 14px;
        font-weight: bolder;
        color: black;
      }
    }
    .teamTable {
      padding: 10px 0;
      .title {
        height: 50px;
      }
      .tableMain {
        .van-row {
          height: 50px;
        }
      }
    }
    .logo {
      padding: 0 15px 10px;
      border-bottom: 1px solid #ebedf0;
      h3 {
        font-size: 14px;
        font-weight: bolder;
      }
      .van-uploader {
        width: 78px;
        height: 78px;
        border: 1px dashed #969799;
        .van-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      img {
        width: 78px;
        height: 78px;
      }
    }
    .badge {
      .van-uploader {
        width: 150px;
        height: 78px;
      }
      img {
        width: 150px;
        height: 78px;
      }
    }
    .add-player {
      position: relative;
    }
    .add-btn-player {
      position: absolute;
      top: 0;
      z-index: 999;
      right: 5px;
      border: none;
    }
    .player-list.van-popup {
      width: 100%;
      height: 100%;
      max-width: 768px; /*px*/
    }

    .team-btn-create {
      max-width: 768px; /*px*/
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      text-align: center;
      background-color: white;
      button:first-child {
        background-color: white;
        color: #185494;
      }
      button:last-child {
        background-color: #185494;
        color: white;
      }
      button {
        font-size: 20px;
        height: 60px;
        padding: 0;
        margin: 0;
        border: none;
      }
    }
    .number-input .header .left-btn {
      padding: 15px;
      color: #1989fa;
      font-size: 14px;
      display: inline-block;
    }

  .number-input .header .right-btn {
    padding: 15px;
    color: #1989fa;
    font-size: 14px;
    display: inline-block;
    float: right;
  }

  .number-input .content {
    padding: 10px 30px 50px 30px;
  }

  }
</style>



// WEBPACK FOOTER //
// src/pages/ucenter/team-detailed-revise.vue